import { Trans, useTranslation } from 'react-i18next';

import { Button, Divider, Modal } from '@cfa/react-core';

interface PlanInUseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const PlanInUseModal: React.FC<PlanInUseModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation();

  return (
    <Modal.Root isOpen={isOpen} onOpenChange={open => !open && onClose()}>
      <Modal.Dialog className="pathway-modal">
        <Modal.Content>
          <Modal.Title>{t('TrainingPlans.planInUse.title')}</Modal.Title>
          <Divider />
          <div className="text-contrast space-y-2 text-left text-sm/[21px]">
            <p>{t('TrainingPlans.planInUse.body')}</p>
            <p>
              <Trans i18nKey="TrainingPlans.planInUse.completedHeading" />
            </p>
            <ul className="list-disc space-y-1 pl-5">
              <li>{t('TrainingPlans.planInUse.completedNoChange')}</li>
            </ul>
            <p>
              <Trans i18nKey="TrainingPlans.planInUse.notCompletedHeading" />
            </p>
            <ul className="list-disc space-y-1 pl-5">
              <li>{t('TrainingPlans.planInUse.newSteps')}</li>
              <li>{t('TrainingPlans.planInUse.removedSteps')}</li>
              <li>{t('TrainingPlans.planInUse.modifiedSteps')}</li>
            </ul>
          </div>
          <Divider />
          <Modal.Footer>
            <Button
              variant="outlined"
              color="secondary"
              className="w-full!"
              onPress={onClose}
            >
              {t('Button.cancel')}
            </Button>
            <Button
              color="secondary"
              variant="filled"
              className="w-full!"
              onPress={onContinue}
              data-testid="PlanInUseContinueButton"
            >
              {t('TrainingPlans.planInUse.continueToEdit')}
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Dialog>
    </Modal.Root>
  );
};

export default PlanInUseModal;
